import useMediaQuery from './publicApi'

export function trainingConverter(trainingValue: number): string {
  // Train scale
  let training: number | string = trainingValue
  switch (true) {
    case training >= 3.5 && training <= 5:
      training = 'Very'
      break
    case training >= 2 && training < 3.5:
      training = 'Medium'
      break
    case training >= 1 && training < 2:
      training = 'Low'
      break
    default:
      training = 'medium'
  }

  return training
}

export function energyConverter(energyValues: number): string {
  // Energy Levels
  let energy: number | string = energyValues
  switch (true) {
    case energy >= 3.5 && energy <= 5:
      energy = 'High'
      break
    case energy >= 2.5 && energy < 3.5:
      energy = 'Moderate'
      break
    case energy >= 1.8 && energy < 2.5:
      energy = 'Low'
      break
    case energy >= 1 && energy < 1.8:
      energy = 'Couch potato'
      break
    default:
      energy = 'Moderate'
  }

  return energy
}

export function sheddingConverter(sheddingAmount: number): string | number {
  // Shedding Scale
  let shedding: number | string = sheddingAmount
  switch (true) {
    case shedding >= 3.5 && shedding <= 5:
      shedding = 'High'
      break
    case shedding >= 2.5 && shedding < 3.5:
      shedding = 'Moderate'
      break
    case shedding >= 1.8 && shedding < 2.5:
      shedding = 'Low'
      break
    case shedding >= 1 && shedding < 1.8:
      shedding = 'Minimal'
      break
  }
  return shedding
}

export function sizeConverter(sizeValues: number): number | string {
  // Size Scale
  let size: number | string = sizeValues
  switch (true) {
    case size >= 4.5 && size <= 5:
      size = 'Very Large'
      break
    case size >= 3.5 && size < 4.5:
      size = 'Large'
      break
    case size >= 2.5 && size < 3.5:
      size = 'Medium'
      break
    case size >= 1.8 && size < 2.5:
      size = 'Small'
      break
    case size >= 1 && size < 1.8:
      size = 'Toy or Teacup'
      break
  }
  return size
}
export function breedNameTextConverter(variables: string) {
  let name: string

  switch (variables) {
    case 'German Shepherd Dog':
      name = 'German Shepherd'
      break
    default:
      name = variables
      break
  }
  return name
}
export function categoryTitleConverter(variables: string) {
  let category: string

  switch (variables) {
    case 'kid_friendly':
      category = 'Kid-Friendly Puppies'
      break
    case 'apartment':
      category = 'Apartment Puppies'
      break
    case 'affordable':
      category = 'Affordable Puppies for Sale Under $1000'
      break
    case 'emotional_support':
      category = 'Emotional Support Puppies'
      break
    case 'doodle':
      category = 'Doodle Puppies'
      break
    case 'service':
      category = 'Service Breed Puppies'
      break
    case 'guard':
      category = 'Guard Breed Puppies'
      break
    case 'small':
      category = 'Small Puppies'
      break
    case 'hypoallergenic':
      category = 'Hypoallergenic Puppies'
      break
    case 'active':
      category = 'Active Lifestyle Puppies'
      break
    case 'therapy':
      category = 'Therapy Breed Puppies'
      break
    case 'trained':
      category = 'Trained Puppies'
      break
    default:
      category = variables
      break
  }
  return category
}

export function reasonTextConverter(variables: string) {
  let reason: string

  switch (variables) {
    case 'PuppyUnavailable':
      reason = 'Puppy unavailable'
      break
    case 'CustomerNotaMatch':
      reason = 'Customer not a match'
      break
    case 'TravelIssue':
      reason = 'Travel issue'
      break
    case 'Other':
      reason = 'Other'
      break
    default:
      reason = variables
      break
  }
  return reason
}

export function documentTextConverter(variables: string) {
  let doc: string

  switch (variables) {
    case 'Registrations':
      doc = 'Registration'
      break
    case 'BusinessLicense':
      doc = 'Business License'
      break
    case 'Certificate':
      doc = 'Certificate'
      break
    case 'Other':
      doc = 'Other'
      break
    default:
      doc = variables
      break
  }
  return doc
}

// Capitalize first letter of string
export function capitalize(string: string): string {
  if (!string) return ''
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// capitalize ever first letter of the words in a string
export function capitalizeFirstLetterOfTitle(string: string) {
  return string
    ?.split(' ')
    .map((word) => capitalize(word))
    .join(' ')
}

export function findWord(word: string) {
  if (word?.includes('Dog')) {
    const array = word.split(' ')
    const index = array.indexOf('Dog')
    return array.slice(0, index).join(' ')
  } else {
    return word
  }
}

export function converterDate(date: string): string {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const year = date.slice(0, 4)
  const month = date.slice(5, 7)
  const day = date.slice(8)

  const monthNumber = parseInt(month)
  let newMonth = ''
  newMonth = months[monthNumber - 1]

  return day + ' ' + newMonth + ' ' + year
}

// BLOG
export function limitShowPuppies(data, relatedPuppies) {
  let relatedPuppiesData
  const length = data?.length

  switch (true) {
    case length < 11800:
      relatedPuppiesData = relatedPuppies.slice(0, 8)
      break
    case length > 11800 && length < 12500:
      relatedPuppiesData = relatedPuppies.slice(0, 13)
      break
    case length >= 12500 && length < 13000:
      relatedPuppiesData = relatedPuppies.slice(0, 14)
      break
    case length >= 13000 && length < 14500:
      relatedPuppiesData = relatedPuppies.slice(0, 16)
      break
    case length >= 14500 && length < 16000:
      relatedPuppiesData = relatedPuppies.slice(0, 18)
      break
    case length >= 16000 && length < 17000:
      relatedPuppiesData = relatedPuppies.slice(0, 22)
      break
    case length >= 17000 && length < 18000:
      relatedPuppiesData = relatedPuppies.slice(0, 23)
      break
    case length >= 18000 && length < 20000:
      relatedPuppiesData = relatedPuppies.slice(0, 25)
      break
    case length >= 20000 || length < 22000:
      relatedPuppiesData = relatedPuppies.slice(0, 20)
      break
    default:
      relatedPuppiesData = relatedPuppies
  }
  return relatedPuppiesData
}

export function slugConverter(word) {
  const arr = word?.split(' ')
  if (arr?.length > 1) {
    const newArr = arr.map((elem) => {
      return elem + '-'
    })

    const slug = newArr.join('')
    return slug.slice(0, slug.length - 1).toLowerCase()
  } else {
    return word?.toLowerCase()
  }
}

export function slugReverter(word: string): string {
  if (word?.includes('-')) {
    return capitalizeFirstLetterOfTitle(word.split('-').join(' '))
  } else {
    return word
  }
}

export function shippingOptionConverter(variables: string) {
  let option: string

  switch (variables) {
    case 'homeDelivery':
      option = 'Home Delivery'
      break
    case 'pickupNearHome':
      option = 'Pickup Near Home'
      break
    case 'borderPickup':
      option = 'Flight Nanny to Canada'
      break
    case 'flightNanny':
      option = 'Flight Nanny to Puerto Rico'
      break
    case 'noFlight':
      option = 'No Flight'
      break
    default:
      option = variables
      break
  }
  return option
}

export const phoneNumberFormatter = (number: string) => {
  const numericPhoneNumber = number.replace(/\D/g, '')
  return numericPhoneNumber.padStart(10, '0')
}

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(price / 100)
}

export function CategoryNameConverter(category) {
  const isMobile = useMediaQuery('(max-width:600px)')
  if (category === 'affordable' && isMobile) {
    return 'Affordable puppies...'
  } else {
    switch (category) {
      case 'kid_friendly':
        return 'Family dogs'
      case 'apartment':
        return 'Apartment Dogs'
      case 'affordable':
        return 'Affordable puppies under $1000'
      case 'small':
        return 'Mini & Teacup Dogs'
      case 'emotional_support':
        return 'Emotional Support Dogs'
      case 'hypoallergenic':
        return 'Hypoallergenic Dogs'
      case 'guard':
        return 'Guard dogs'
      case 'hunting':
        return 'Hunting dogs'
      case 'service':
        return 'Service dogs'
      case 'active':
        return 'Active Lifestyle Dogs'
      case 'doodle':
        return 'Doodles'
    }
  }
  return null
}
